import React from 'react';
import { render } from 'react-dom';
import EventSubmit from './apps/EventSubmit/EventSubmit';

// Events Form Application
const eventSubmit = document.getElementById('event-submit-app');
if (eventSubmit) render(<EventSubmit {...eventSubmit.dataset} />, eventSubmit);
